import React from "react";
import Select from "@/components/Select";
import useTeams from "@/hooks/useTeams";

export interface RouteToTeamValue {
  teamId: number;
}

interface Props {
  value: RouteToTeamValue;
  updateValue: (value: RouteToTeamValue) => void;
}

export default function RouteToTeamRuleForm({ value, updateValue }: Props) {
  const { teams } = useTeams();

  const teamOptions = Array.isArray(teams)
    ? teams.reduce((acc, team) => {
        acc[team.id.toString()] = team.name;
        return acc;
      }, {} as Record<string, string>)
    : {};

  return (
    <div className="space-y-2">
      <p className="text-sm text-slate-600">
        Route the conversation to a specific team when conditions match. If no
        rule matches, the deployment&apos;s default team is used.
      </p>
      <Select
        options={teamOptions}
        value={value?.teamId?.toString() ?? ""}
        onChange={(v) => updateValue({ teamId: Number(v) })}
      />
    </div>
  );
}
